export default {"src":"/_next/static/media/qr-code-download.97a1c57b.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};